//const HOST = 'https://backoffice.rocabee.com/rocabee/translations/free-play/tavla/';
const HOST = '';

class LocaleManager {
    constructor()
    {
        this.localesDir = './assets/locales';
        this.defaultLocale = 'en';
        this.availableLocales = [
            'cs', 'de', 'el', 'en',
            'es', 'fi', 'fr', 'hu',
            'is', 'it', 'lv', 'nl',
            'no', 'pl', 'pt', 'sr',
            'sv', 'tr'
        ];

        this.change = new Phaser.Signal();
    }

    init(loader, locale)
    {
        this._loader = loader;
        this._current = {};

        this.locale = locale;
    }

    updateLocale()
    {
        const file = `${this.locale}.json`;

        if (this._loader.cache.getText[file])
        {
            this.updateFromCache();
            return false;
        }
        else
        {
            this._localeLoadedHandlerBinding = this._loader.onFileComplete.add(this.localeLoadedHandler, this);
            this._loader.text(file, `${this.localesDir}/${file}`);
            return true;
        }
    }

    localeLoadedHandler(progress, file, success)
    {
        if (file === `${this.locale}.json` && success)
        {
            this._localeLoadedHandlerBinding.detach();
            this.updateFromCache();
        }
    }

    updateFromCache()
    {
        this._current = JSON.parse(this._loader.cache.getText(`${this.locale}.json`));
        this.change.dispatch();
    }

    getString(key)
    {
        return this._current[key] || key;
    }

    get locale()
    {
        return this._locale;
    }

    set locale(value)
    {
        if (this.locale === value)
        {
            return;
        }

        console.log('Requested locale:', value);
        value = value || this.defaultLocale;
        this._locale = this.availableLocales.indexOf(value) !== -1 ? value : this.defaultLocale;
        console.log('Resolved locale:', this._locale);

        //to properly reuse loader
        if (this.updateLocale())
        {
            this._loader.preloadSprite = null;
            this._loader.start();
        }
    }
}

export default new LocaleManager();